// extracted by mini-css-extract-plugin
export var bg = "style-module--bg--522dd";
export var mySwiper = "style-module--mySwiper--edcd8";
export var swiperBtnNext = "style-module--swiper-btn-next--bd17f";
export var swiperBtnPrev = "style-module--swiper-btn-prev--6ba0a";
export var swiperButtons = "style-module--swiper-buttons--e72e0";
export var title = "style-module--title--996e7";
export var vid = "style-module--vid--0f19b";
export var video = "style-module--video--3b5fe";
export var wrap = "style-module--wrap--fde52";